import { checkIsServiceNonTopUp, PaymentPayee } from '@entities/tsp'
import { CommissionDataByServiceIdType } from '@entities/denomination'

export const getCardAdditionalAmount = (
  amount: number,
  commissionData: CommissionDataByServiceIdType,
  payee: PaymentPayee,
  showVouchersForm: boolean
) => {
  if (Object.keys(commissionData).includes(payee.features?.tsp_url as string)) {
    return 'coef' in commissionData[payee.features?.tsp_url as string]
      ? amount * Number(commissionData[payee.features?.tsp_url as string].coef)
      : Number(commissionData[payee.features?.tsp_url as string].amount)
  }

  return checkIsServiceNonTopUp(showVouchersForm, payee) && amount ? Number(commissionData.vouchers.amount) / 2 : 0
}
